//Favourites Utilities file

import Util from "./util";
var UtilObject = new Util();

export default class favUtil {
  getCustomerFavouriteList = () => {
    var cookies = UtilObject.getAllCookies();
    if (cookies.hasOwnProperty("CUSTOMER_ID")) {
      return new Promise((resolve) => {
        $.ajax({
          url: baseURL + "api/customer/Account/getFavorites",
          type: "GET",
          headers: { Authorization: X_API_KEY },
          success: (result) => {
            resolve(result);
          },
          error: (result) => {
            resolve("ERROR OCCURED");
          },
        });
      });
    } else {
      return Promise.resolve("YOU NEED TO LOG IN");
    }
  };

  favouritesToggle = (vendorID, status) => {
    var cookies = UtilObject.getAllCookies();
    if (cookies.hasOwnProperty("CUSTOMER_ID")) {
      return new Promise((resolve) => {
        $.ajax({
          url: baseURL + "api/customer/Account/AddRemoveFavorite",
          type: "POST",
          data: {
            Vendor_ID: vendorID,
            Status: status,
          },
          headers: { Authorization: X_API_KEY },
          success: (result) => {
            resolve(result);
          },
          error: (error) => {
            resolve("ERROR OCCURED");
          },
        });
      });
    } else {
      return Promise.resolve("YOU NEED TO LOG IN");
    }
  };
}
